import { getBookingsServiceApiUrl } from '../selectors/selectors';

export default {
  fetch: ({ data, envConfig }, action, state) => ({
    url: `${getBookingsServiceApiUrl(state)}/booking/submit`,
    opts: {
      method: 'POST',
      credentials: 'include',
      headers: {
        client_id: '684C957199C3BE6C153A778D1986032B',
        'Content-Type': 'application/json',
        'x-tlr-env': envConfig?.['x-tlr-env'],
      },
      body: JSON.stringify(data),
    },
  }),
};
